export default () => {
  return {
    devices: [],
    totalInstalls: 0,
    usedInstalls: 0
  }
}
